import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import Icon from '../Icon';
import Button from '../Button';
import s from './SortInput.css';

class SortInput extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      searchTerm: '',
      readonly: false,
    };
  }

  componentWillMount() {
    const { placeholder, valueholder } = this.props;
    if (placeholder === valueholder) {
      this.setState({
        searchTerm: valueholder,
      });
      this.setState({
        readonly: true,
      });
    }
  }

  updateSearch = event => {
    const searchTerm = event.target.value;
    this.setState({
      searchTerm,
      }, () => {
      // if (this._throttleTimeout) {
      //   clearTimeout(this._throttleTimeout);
      // }

      // this._throttleTimeout = setTimeout(this.props.onChange, this.props.throttle, searchTerm);
    });
  };

  _handleKeyDown = event => {
    if (event.key === 'Enter') {
      this.props.onChange(this.state.searchTerm);
      this.setState({
        readonly: !this.state.readonly,
      });
    }

    // if (event.keyCode === 8) {
    //   this.setState({
    //     searchTerm: '',
    //   });
    //   this.props.onChange('');
    //   this.setState({
    //     readonly: !this.state.readonly,
    //   });
    // }
  };

  setSearch = event => {
    this.props.onChange(this.state.searchTerm);
    this.setState({
      readonly: !this.state.readonly,
    });
  };

  clearSearch = event => {
    this.setState({
      searchTerm: '',
    });
    this.props.onChange('');
    this.setState({
      readonly: !this.state.readonly,
    });

  };

  render() {
    const wrappedClass = this.state.searchTerm 
      ? classNames(s.SortInput, s.is_active, s[this.props.className])
      : classNames(s.SortInput, s.is_active);

    if (!this.state.readonly) {
      return (
        <div className={wrappedClass}>
          <label htmlFor={this.props.name} className={s.SortInput_label}>
            {this.props.title ? <FormattedMessage id={this.props.title} /> : null}
          </label>
          <input
            className={s.SortInput_field}
            type="search"
            name={this.props.name}
            id={this.props.name}
            placeholder={this.props.placeholder}
            value={this.state.searchTerm}
            onChange={this.updateSearch}
            onKeyDown={this._handleKeyDown}
          />
          <Button
            disabled = {this.props.requestInProgress ? true : false}
            buttonClass={'search'}
            block
            type="button" 
            onClick={this.setSearch}>
              <Icon iconName="lupka" className={s.SortInput_icon} size={20} />
            </Button>
        </div>
      );
    }
    return (
      <div className={wrappedClass}>
        <label htmlFor={this.props.name} className={s.SortInput_label}>
          {this.props.title ? <FormattedMessage id={this.props.title} /> : null}
        </label>
        <input
          readOnly
          className={s.SortInput_field}
          type="search"
          name={this.props.name}
          id={this.props.name}
          placeholder={this.props.placeholder}
          value={this.state.searchTerm}
          onChange={this.updateSearch}
          onKeyDown={this._handleKeyDown}
        />
        <Button
          disabled = {this.props.requestInProgress ? true : false}
          buttonClass={'search'}
          block
          type="button" 
          onClick={this.clearSearch}>
            <Icon iconName="odrzuc_margin" className={s.SortInput_icon} size={20} />
          </Button>
      </div>
    );
  }
}

SortInput.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  valueholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  caseSensitive: PropTypes.bool,
  requestInProgress: PropTypes.bool,
  throttle: PropTypes.number,
  intl: intlShape.isRequired,
};

SortInput.defaultProps = {
  throttle: 200,
  requestInProgress: false,
};

export default injectIntl(withStyles(s)(SortInput));



// WEBPACK FOOTER //
// ./src/components/SortInput/SortInput.js